import { render, staticRenderFns } from "./pageb.vue?vue&type=template&id=ea5611f8&scoped=true"
import script from "./pageb.vue?vue&type=script&lang=js"
export * from "./pageb.vue?vue&type=script&lang=js"
import style0 from "./pageb.vue?vue&type=style&index=0&id=ea5611f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5611f8",
  null
  
)

export default component.exports